import { compose, setDisplayName, lifecycle } from 'recompose'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchElements } from 'store/elements/actions'
import { selectElements, selectFetchElementsStatus } from 'store/elements/selectors'

const mapStateToProps = (state) => ({
  elements: selectElements(state),
  fetchElementsStatus: selectFetchElementsStatus(state),
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({ fetchElements }, dispatch)
);

export const withFetchElements = () => (
  compose(
    setDisplayName('Elements'),
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({
      componentDidMount() {
        const { elements, fetchElements } = this.props
        if(!elements.length){
          fetchElements()
        }
      },
    }),
  )
)

export const withElementsState = () => (
  compose(
    setDisplayName('Elements'),
    connect(mapStateToProps)
  )
)



// WEBPACK FOOTER //
// ./src/store/elements/elementHocs.js